/**
 * EditServiceModal - Modal for editing manual service data
 */

import { useEffect } from "react";
import { Modal, Form, Input, message } from "antd";
import type { ManualService } from "@/services/subscriptionsService";
import { updateManualService } from "@/services/subscriptionsService";

interface EditServiceModalProps {
  service: ManualService | null;
  open: boolean;
  onClose: () => void;
}

export default function EditServiceModal({ service, open, onClose }: EditServiceModalProps) {
  const [form] = Form.useForm();

  useEffect(() => {
    if (service && open) {
      form.setFieldsValue({
        plan: service.plan || "",
        cost: service.cost || "",
        expirationDate: service.expirationDate || "",
        notes: service.notes || "",
        deepLink: service.deepLink || "",
      });
    }
  }, [service, open, form]);

  const handleSave = async () => {
    if (!service) return;

    try {
      const values = await form.validateFields();
      await updateManualService(service.id, values);
      message.success(`${service.name} updated`);
      onClose();
    } catch (error) {
      console.error("Failed to save service:", error);
      message.error("Failed to save changes");
    }
  };

  return (
    <Modal
      title={`Edit ${service?.name || "Service"}`}
      open={open}
      onOk={handleSave}
      onCancel={onClose}
      okText="Save"
      destroyOnClose
    >
      <Form form={form} layout="vertical" style={{ marginTop: 16 }}>
        <Form.Item name="plan" label="Plan">
          <Input placeholder="e.g. Free, Pro, Business" />
        </Form.Item>
        <Form.Item name="cost" label="Cost">
          <Input placeholder="e.g. $25/mo, €0 (free tier)" />
        </Form.Item>
        <Form.Item name="expirationDate" label="Expiration Date">
          <Input placeholder="YYYY-MM-DD" />
        </Form.Item>
        <Form.Item name="notes" label="Notes">
          <Input.TextArea rows={3} placeholder="Any relevant notes..." />
        </Form.Item>
        <Form.Item name="deepLink" label="Console Link">
          <Input placeholder="https://..." />
        </Form.Item>
      </Form>
    </Modal>
  );
}
